/* unplugin-vue-components disabled */import { render } from "./share-dropdown.vue?vue&type=template&id=6ff8369f&scoped=true"
import script from "./share-dropdown.vue?vue&type=script&lang=js"
export * from "./share-dropdown.vue?vue&type=script&lang=js"

import "./share-dropdown.vue?vue&type=style&index=0&id=6ff8369f&lang=stylus"
import "./share-dropdown.vue?vue&type=style&index=1&id=6ff8369f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff8369f"],['__file',"src/pages/chats/chat-sharing/share-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff8369f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff8369f', __exports__)) {
    api.reload('6ff8369f', __exports__)
  }
  
  module.hot.accept("./share-dropdown.vue?vue&type=template&id=6ff8369f&scoped=true", () => {
    api.rerender('6ff8369f', render)
  })

}


export default __exports__